import CasRouterTabs from 'src/compass/shared/components/CasTabsView/CasRouterTabs';
import NoticeMissingTab from './NoticeMissingTab';
import SendTab from './SendTab';
import DocusignReviewTab from './DocusignReviewTab';
import BillReviseTab from './BillReviseTab';
import FinalReviewTab from './FinalReviewTab';
import CallbackTab from './CallbackTab';

export const TabListTodo = {
  noDefault: true,
  tabs: [
    { label: 'Notice Missing', children: <NoticeMissingTab/>, icon:'subway:missing', color: 'info' },
    { label: 'Send', children: <SendTab />, icon:'material-symbols:mail-outline', color: 'warning' },
    { label: 'Docusign Review', children: <DocusignReviewTab />, icon:'material-symbols:attach-file' },
    { label: 'Callback', children: <CallbackTab />, icon:'mdi:phone' },
    { label: 'Final Review', children: <FinalReviewTab />, icon: 'material-symbols:verified' },
    { label: 'Bill Revise', children: <BillReviseTab />, icon:'la:file-invoice-dollar', color: 'info' },
  ]
};

export default function TodoTab() {
  return (
    <CasRouterTabs
      asButtons
      baseUrl="/endorsements/claimtracking/todo"
      tabList={TabListTodo.tabs}
    />
  );
}
